<template>
  <el-container>
    <el-header height="80px">
      <el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" @select="handleSelect" id="elMenu" >
        <el-menu-item @click="back()">后退</el-menu-item>
        <el-menu-item index="/qipanzhouIndex">首页</el-menu-item>
        <el-menu-item index="/qipanzhou/gasClamp">全桥实时数据</el-menu-item>
        <el-submenu index="/qipanzhou/anchorRoom">
          <template slot="title">锚室</template>
          <el-menu-item index="/qipanzhou/anchorRoom/huangshiWest">黄石侧西锚室</el-menu-item>
          <el-menu-item index="/qipanzhou/anchorRoom/huangshiEast">黄石侧东锚室</el-menu-item>
          <el-menu-item index="/qipanzhou/anchorRoom/huanggangWest">黄冈侧西锚室</el-menu-item>
          <el-menu-item index="/qipanzhou/anchorRoom/huanggangEast">黄冈侧东锚室</el-menu-item>
        </el-submenu>
        <el-submenu index="/qipanzhou/mainCable/huanggang">
          <template slot="title">主缆</template>
          <el-menu-item index="/qipanzhou/mainCable/huangshi">黄石主缆除湿机</el-menu-item>
          <el-menu-item index="/qipanzhou/mainCable/huanggang">黄冈主缆除湿机</el-menu-item>
        </el-submenu>
        <el-menu-item index="/qipanzhou/saddleRoom">鞍室</el-menu-item>
        <el-submenu index="/qipanzhou/steelBoxDehumidifier/huangshi">
          <template slot="title">黄石中跨箱梁</template>
          <el-menu-item index="/qipanzhou/steelBoxDehumidifier/huangshi">黄石中跨箱梁除湿机</el-menu-item>
          <el-menu-item index="/qipanzhou/steelBoxFan/huangshi">黄石中跨箱梁风机</el-menu-item>
        </el-submenu>
        <el-submenu index="/qipanzhou/steelBoxDehumidifier/huanggang">
          <template slot="title">黄冈中跨箱梁</template>
          <el-menu-item index="/qipanzhou/steelBoxDehumidifier/huanggang">黄冈中跨箱梁除湿机</el-menu-item>
          <el-menu-item index="/qipanzhou/steelBoxFan/huanggang">黄冈中跨箱梁风机</el-menu-item>
        </el-submenu>
        <el-submenu index="/qipanzhou/steelBoxSideSpan/upstream">
          <template slot="title">南边跨箱梁除湿机</template>
          <el-menu-item index="/qipanzhou/steelBoxSideSpan/upstream">南边跨上游箱梁除湿机</el-menu-item>
          <el-menu-item index="/qipanzhou/steelBoxSideSpan/downstream">南边跨下游箱梁除湿机</el-menu-item>
        </el-submenu>
        <el-menu-item index="/qipanzhou/bridgeImg">全桥除湿总体布置图</el-menu-item>

        <el-submenu index="/qipanzhou/dataHistory?bridgeId=2003ac27-8590-4b54-9022-0a9c92e809c7&scenarioId=TBD">
          <template slot="title">数据历史</template>
          <el-menu-item index="/qipanzhou/dataHistory?bridgeId=2003ac27-8590-4b54-9022-0a9c92e809c7&scenarioId=TBD"> 查询数据历史 </el-menu-item>
          <el-menu-item index="/qipanzhou/dataHistory?bridgeId=2003ac27-8590-4b54-9022-0a9c92e809c7"> 自定义数据历史 </el-menu-item>
        </el-submenu>
      </el-menu>
      <HeaderTime bridgeName="HUBEI" :bridgeId="bridgeId" :id2Path="id2Path" :envInfo="envInfo"></HeaderTime>
    </el-header>
    <el-main class="el-main qi-pan-zhou">
      <router-view></router-view>
    </el-main>
  </el-container>
</template>
<script>
export default {
  name: "sutong",
  data() {
    return {
      bridgeId: "2003ac27-8590-4b54-9022-0a9c92e809c7",
      envInfo: {
        envId: "5d7b2b84-072d-4376-808e-dcb8d68ff11a",
        weather: "38192ed3-4c80-4804-8d69-9d7834510f37",
        humidity: "662f45d9-11cc-4dd9-ab27-e3cbc989fb3f",
        temperature: "637231c6-b9ad-4161-a51f-59047f213581",
      },
      id2Path: {},
      activeIndex: "",
      historyScenarioList: [],
    };
  },
  mounted() {
    this.activeIndex = this.$route.fullPath;

    document.getElementById("elMenu").addEventListener(
      "mousewheel",
      (e) => {
        let scrollWidth = document.getElementById("elMenu").scrollWidth;
        let clientWidth = document.getElementById("elMenu").clientWidth;

        let scrollMin = 0;
        let scrollMax = scrollWidth - clientWidth;
        let step = 30;

        if (e.deltaY > 0) {
          document.getElementById("elMenu").scrollLeft += step;
          if (document.getElementById("elMenu").scrollLeft > scrollMax) {
            document.getElementById("elMenu").scrollLeft = scrollMax;
          }
        } else if (e.deltaY < 0) {
          document.getElementById("elMenu").scrollLeft += step * -1;
          if (document.getElementById("elMenu").scrollLeft < scrollMin) {
            document.getElementById("elMenu").scrollLeft = scrollMin;
          }
        }
      },
      true
    );

  },
  watch: {
    $route() {
      this.activeIndex = this.$route.fullPath;
    },
  },
  methods: {
    back() {
      window.history.back();
    },
    handleSelect(key) {
      if (key !== this.activeIndex) {
        this.activeIndex = key;
        this.$router.push(key);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-menu-demo {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;

  overflow-x: scroll;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background: transparent;;
  display: none;
}
</style>